var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.37502 0.333374H14.625C16.0692 0.333374 17.2494 1.46375 17.3291 2.88802L17.3334 3.04171V10.9584C17.3334 12.4026 16.203 13.5827 14.7787 13.6624L14.625 13.6667H3.37502C1.93083 13.6667 0.750649 12.5363 0.670974 11.1121L0.666687 10.9584V3.04171C0.666687 1.59751 1.79707 0.417336 3.22133 0.337661L3.37502 0.333374H14.625H3.37502ZM16.0834 4.81087L9.29111 8.38645C9.13493 8.46865 8.95263 8.48039 8.78899 8.42168L8.70893 8.38645L1.91669 4.81171V10.9584C1.91669 11.7235 2.50595 12.351 3.25541 12.4119L3.37502 12.4167H14.625C15.3902 12.4167 16.0177 11.8274 16.0785 11.078L16.0834 10.9584V4.81087ZM14.625 1.58337H3.37502C2.60988 1.58337 1.98236 2.17263 1.92152 2.9221L1.91669 3.04171V3.39921L9.00002 7.12709L16.0834 3.39837V3.04171C16.0834 2.27656 15.4941 1.64905 14.7446 1.58821L14.625 1.58337Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.ca9883f243d2b6e1315f88e43e9007ed.svg";
export { ForwardRef as ReactComponent };